import { render } from "./AddDefinitionNotes.vue?vue&type=template&id=621c653a&ts=true"
import script from "./AddDefinitionNotes.vue?vue&type=script&lang=ts"
export * from "./AddDefinitionNotes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__